import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["tip", "trigger", "placement", "children", "disableMaxWidth"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { PopoverPrivate } from '@snack-uikit/popover-private';
import { DEFAULT_FALLBACK_PLACEMENTS } from './constants';
import styles from "./styles.module.css";
import { jsx as _jsx } from "react/jsx-runtime";
export function MobileTooltip(_ref) {
  var tip = _ref.tip,
    _ref$trigger = _ref.trigger,
    trigger = _ref$trigger === void 0 ? 'hoverAndFocusVisible' : _ref$trigger,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    children = _ref.children,
    _ref$disableMaxWidth = _ref.disableMaxWidth,
    disableMaxWidth = _ref$disableMaxWidth === void 0 ? false : _ref$disableMaxWidth,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (!children) {
    return null;
  }
  return /*#__PURE__*/_jsx(PopoverPrivate, _objectSpread(_objectSpread({
    placement: placement,
    popoverContent: /*#__PURE__*/_jsx("div", {
      className: styles.tooltipContainer,
      "data-disable-max-width": disableMaxWidth,
      children: tip
    }),
    trigger: trigger,
    arrowContainerClassName: styles.tooltipArrowContainer,
    arrowElementClassName: styles.tooltipArrowElement,
    hasArrow: true,
    fallbackPlacements: DEFAULT_FALLBACK_PLACEMENTS,
    className: styles.tooltip
  }, otherProps), {}, {
    children: children
  }));
}